import axios from "axios";
// import logout from "../logout.js";
import { Encrypt_Value, Decrypt_Value } from "../MiddleWare/EncryptDecrypt";

var headers = {};
let baseURL;

const storedToken = localStorage.getItem("token");

if (storedToken) {
  let DBHost;
  let finalloginurl;

  if (window.location.href.includes("localhost")) {
    DBHost = "default";
    finalloginurl = process.env.REACT_APP_BACKEND_URL;
  } else {
    let firstDot = window.location.hostname.split(".");
    if (
      firstDot[0] !== "ehr" &&
      firstDot[0] !== "ehr1" &&
      firstDot[0] !== "test" &&
      firstDot[0] !== "mumbai" &&
      firstDot[0] !== "dev" &&
      firstDot[0] !== "production"
    ) {
      DBHost = firstDot[0];
      finalloginurl = process.env.REACT_APP_BACKEND_URL.replace("oemr", DBHost);
    } else {
      DBHost = "default";
      finalloginurl = process.env.REACT_APP_BACKEND_URL.replace(
        "oemr",
        firstDot[0],
      );
    }
  }

  headers.Authorization = storedToken;
  baseURL = finalloginurl + DBHost + "/api";
} else {
  let DBHost;
  let finalurl;

  if (window.location.href.includes("localhost")) {
    DBHost = "default";
    finalurl = process.env.REACT_APP_BACKEND_URL;
  } else {
    let firstDot = window.location.hostname.split(".");
    if (
      firstDot[0] !== "ehr" &&
      firstDot[0] !== "ehr1" &&
      firstDot[0] !== "test" &&
      firstDot[0] !== "mumbai" &&
      firstDot[0] !== "dev" &&
      firstDot[0] !== "production"
    ) {
      DBHost = firstDot[0];
      finalurl = process.env.REACT_APP_BACKEND_URL.replace("oemr", DBHost);
    } else {
      DBHost = "default";
      finalurl = process.env.REACT_APP_BACKEND_URL.replace("oemr", firstDot[0]);
    }
  }

  baseURL = finalurl + DBHost;
  headers = {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  };
}

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

const refreshToken = async () => {
  try {
    const client_id = process.env.REACT_APP_BACKEND_CLIENT_ID;
    const refresh_token = localStorage.getItem("refresh_token");

    const details = {
      grant_type: "refresh_token",
      client_id,
      refresh_token,
    };

    let Encrypt_details = Encrypt_Value(details, "vozo");

    const response = await axios.post(
      baseURL + "/vozo/refresh",
      Encrypt_details,
    );

    const Decrpt_response = Decrypt_Value(response.data, "vozo");

    localStorage.setItem("token", Decrpt_response.token);
    localStorage.setItem("refresh_token", Decrpt_response.refresh_token);
    localStorage.setItem("login_time", Decrpt_response.token_exp);
  } catch (error) {
    console.error("Refresh Token Creation Failed");
    localStorage.clear();
    window.location.href = "/";
    throw error;
  }
};

let isRefreshing = false;
let refreshPromise = null;

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.response) {
      console.error("Network or Server Error:", error.message);
      return Promise.reject(error);
    }

    const { status, data } = error.response;

    const originalRequest = error.config;

    const isTokenExpired = status === 401;

    const isRefreshApi = originalRequest?.url?.includes("/vozo/refresh");

    if (isTokenExpired && !isRefreshApi && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        refreshPromise = refreshToken()
          .then(() => {
            console.log("Refresh Token Callback Passed");
          })
          .catch((err) => {
            console.error("Refresh Token Callback Failed");
            throw err;
          })
          .finally(() => {
            isRefreshing = false;
          });
      }

      try {
        await refreshPromise;

        const newToken = localStorage.getItem("token");
        originalRequest.headers.Authorization = newToken;

        return axiosInstance(originalRequest);
      } catch (err) {
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
